module.exports = __webpack_public_path__ + "static/Oil Decking-6975388e421b89f39254471f808a1a4f.jpg";